var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCsvIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 41,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#CSVIcon_svg__a)",
  d: "M32.25 1.333H3.75C1.679 1.333 0 2.843 0 4.705v32.368c0 1.862 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.372V4.705c0-1.862-1.679-3.372-3.75-3.372Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M32.25 1.333H3.75C1.679 1.333 0 2.843 0 4.705v32.368c0 1.862 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.372V4.705c0-1.862-1.679-3.372-3.75-3.372Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#CSVIcon_svg__b)",
  d: "M32.25 0H3.75C1.679 0 0 1.51 0 3.372v32.367c0 1.863 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.371V3.371C36 1.51 34.321 0 32.25 0Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#CSVIcon_svg__c)",
  d: "M32.25 0H3.75C1.679 0 0 1.51 0 3.372v32.367c0 1.863 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.371V3.371C36 1.51 34.321 0 32.25 0Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "M32.25 0H3.75C1.679 0 0 1.51 0 3.372v32.367c0 1.863 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.371V3.371C36 1.51 34.321 0 32.25 0Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.5 27.514h1.25v1.875H10.5a2.468 2.468 0 0 1-2.5-2.5v-15c0-1.367 1.094-2.5 2.5-2.5h6.445c.664 0 1.29.273 1.758.742l3.555 3.554c.469.47.742 1.094.742 1.758v5.196h-1.875v-5H18c-.703 0-1.25-.547-1.25-1.25v-3.125H10.5a.642.642 0 0 0-.625.625v15c0 .351.273.625.625.625Zm5.313-4.375h.624c.86 0 1.563.703 1.563 1.562v.313a.642.642 0 0 1-.625.625.617.617 0 0 1-.625-.625V24.7a.336.336 0 0 0-.313-.312h-.625a.308.308 0 0 0-.312.312v3.125c0 .195.117.313.313.313h.624a.308.308 0 0 0 .313-.313v-.312c0-.313.273-.625.625-.625.313 0 .625.312.625.625v.312c0 .899-.703 1.563-1.563 1.563h-.625c-.898 0-1.562-.664-1.562-1.563v-3.125c0-.86.664-1.562 1.563-1.562Zm5.195 0h1.367c.313 0 .625.312.625.625a.642.642 0 0 1-.625.625h-1.367c-.313 0-.508.234-.508.547 0 .195.117.351.273.468l1.485.625a1.802 1.802 0 0 1 1.055 1.602c0 .976-.82 1.758-1.797 1.758h-1.641a.617.617 0 0 1-.625-.625c0-.313.273-.625.625-.625h1.64c.313 0 .547-.196.547-.508a.508.508 0 0 0-.312-.469l-1.484-.625c-.625-.273-1.016-.937-1.016-1.601 0-.977.781-1.797 1.758-1.797Zm3.867 0c.313 0 .625.312.625.625v1.25c0 .898.195 1.797.625 2.578.39-.781.625-1.68.625-2.578v-1.25c0-.313.273-.625.625-.625.313 0 .625.312.625.625v1.25c0 1.367-.43 2.695-1.172 3.828l-.195.273a.57.57 0 0 1-.508.274c-.234 0-.43-.078-.547-.274l-.195-.273a6.973 6.973 0 0 1-1.133-3.828v-1.25c0-.313.273-.625.625-.625Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "CSVIcon_svg__a",
  x1: 0,
  x2: 36,
  y1: 20.889,
  y2: 20.889,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#147F2C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CSVIcon_svg__b",
  x1: 0,
  x2: 36,
  y1: 19.556,
  y2: 19.556,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B31217"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3017E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CSVIcon_svg__c",
  x1: 0,
  x2: 36,
  y1: 19.556,
  y2: 19.556,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#147F2C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B700"
})))));
export { SvgCsvIcon as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTlhNzA2ZDNkYWI3M2E2YmQ0MDAyYjExZDhkYWVkNDMuc3ZnIjs=";